module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "blog-item"
  }, [_c('router-link', {
    staticClass: "title",
    attrs: {
      "tag": "h2",
      "to": {
        name: 'Post',
        params: {
          slug: _vm.post.slug
        }
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.post.title) + "\n  ")]), _vm._v(" "), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm._f("timePretty")(_vm.post.date)))]), _vm._v(" "), _vm._l((_vm.post.tags), function(tag) {
    return _c('span', {
      staticClass: "tag",
      on: {
        "click": function($event) {
          _vm.fetchTag(tag.name)
        }
      }
    }, [_vm._v("#" + _vm._s(tag.name))])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-918bcd46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PostItem.vue
// module id = 175
// module chunks = 1